import { createContext, useContext } from 'react';
import { EditPageContextInterface } from './EditPage.types';

export const EditPageContext = createContext<EditPageContextInterface>({
  isEditable: false
});

export const useEditPageContext = () => useContext(EditPageContext);
